import { getAmplitudeInstance } from '../amplitudeHelpers';
import VisitationDisplayMode from '../enums/VisitationDisplayMode';

type logTrailDetailsVisitationDisplayModeChangedParams = {
  display_mode_from: VisitationDisplayMode;
  display_mode_to: VisitationDisplayMode;
  trail_id: number;
};

/**
 * User changed the display mode between By Day and By Month
 * @param params - Attributes to log with the amplitude event
 * @param params.display_mode_from - The display mode before the change.
 * @param params.display_mode_to - The display mode after the change.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsVisitationDisplayModeChanged = (
  { display_mode_from, display_mode_to, trail_id }: logTrailDetailsVisitationDisplayModeChangedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details visitation display mode changed',
    { 'display mode from': display_mode_from, 'display mode to': display_mode_to, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsVisitationDisplayModeChanged;
